import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { FatherService } from './father.service';
import { LocalstorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends FatherService{

  constructor(
    httpClient: HttpClient,
    localstorageService: LocalstorageService
  ) {
    super(httpClient, localstorageService);
  }

  login(login: string, password: string) {
    return this.post('/api-license/auth/login', {login, password})
  }

  /**
   * Запрашивает лицензию для заданного пользователя и сохраняет её в localStorage.
   */
  loadLicense(login: string, password: string) {
    return this.post('/api-license/license-data/license-by-user_name_and_password', { login, password })
      .pipe(
        tap((license: any) => {
          if (license && !license.error) {
            this.localstorageService.set('license', license);
          }
        })
      );
  }
}
